import { ScrollTrigger } from "@/lib/motion/gsap";

export function killTrigger(id: string) {
  ScrollTrigger.getById(id)?.kill(true);
}

let scrollActive = false;
let scrollBound = false;

export function isScrollActive() {
  return scrollActive;
}

function bindScrollFlags() {
  if (scrollBound) return;
  scrollBound = true;
  ScrollTrigger.addEventListener("scrollStart", () => {
    scrollActive = true;
  });
  ScrollTrigger.addEventListener("scrollEnd", () => {
    scrollActive = false;
  });
}

/**
 * scroll-spine `et(id, dir, cb)` — fire the callback, nothing else.
 * Original reverse start is `10% 0%` (ADR-012 leaked `45%` and caused early reverses).
 */
export function et(id: string, dir: "in" | "reverse", cb: () => void) {
  bindScrollFlags();
  const stId = `${id}-${dir}`;
  killTrigger(stId);
  const base = { id: stId, trigger: `#${id}`, scrub: 1 as const };
  if (dir === "in") {
    ScrollTrigger.create({
      ...base,
      start: "50% 0%",
      end: "100% 100%",
      onEnter: () => cb(),
    });
  } else {
    ScrollTrigger.create({
      ...base,
      start: "10% 0%",
      end: "100% 100%",
      onEnterBack: () => cb(),
    });
  }
}

/** Test helper / teardown */
export function resetReconcileForTests() {
  scrollBound = false;
  scrollActive = false;
}
